import { useLocation } from 'react-use';

import { catchAll } from '@sorare/routing';

import {
  ANY_SPORT_MARKET,
  ANY_SPORT_MY_CARDS,
  ANY_SPORT_PLAY,
  ANY_SPORT_SCOUTING_CENTER,
} from 'constants/__generated__/routes';
import { matchAnySportPath } from 'lib/routing/generateSportPath';

import { InGameCurrencyAgreggated } from '../NewAppNavigation/UserCurrencies/useUserCurrencies';

export const useExpandedCurrencies = () => {
  const { pathname } = useLocation();

  if (!pathname) {
    return [];
  }

  const isPlay = !!matchAnySportPath(catchAll(ANY_SPORT_PLAY), pathname);
  const isScoutingCenter = !!matchAnySportPath(
    catchAll(ANY_SPORT_SCOUTING_CENTER),
    pathname
  );
  const isMarket = !!matchAnySportPath(catchAll(ANY_SPORT_MARKET), pathname);
  const isMyCards = !!matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS), pathname);

  if (isPlay || isScoutingCenter || isMarket) {
    return [InGameCurrencyAgreggated.SHARDS];
  }
  if (isMyCards) {
    return [InGameCurrencyAgreggated.XP, InGameCurrencyAgreggated.ENERGY];
  }

  return [];
};
